import React, {Suspense} from 'react';
import { Router } from 'react-router-dom';
import { render } from 'react-dom';

import { history } from './_helpers';
import { accountService, i18next } from './_services';
import { App } from './App.jsx';

import './_style/styles.less';

// set the global settings.

// attempt silent token refresh before startup
accountService.refreshToken().finally(startApp);

// start app
function startApp() { 
    render(
        <Suspense fallback={"App is loading ..."}>
            <Router history={history}>
                <App history={history} />
            </Router>
        </Suspense>, 
        document.getElementById('app')
    );
}

//QR Code Generator: npm i react-qr-code
//import QRCode from "react-qr-code";
// <QRCode size={256} value={value} />